import { FC } from 'react';
import { IQuarterBtn, IQuarters } from '../types';

const FinancialQuarterBtn: FC<IQuarterBtn> = ({
  quarterNumber,
  documentUrl,
}) => {
  if (documentUrl) {
    return (
      <a
        className="financial-results__table--quarter-btn"
        href={documentUrl}
      >{`Q${quarterNumber}`}</a>
    );
  }
  return (
    <div className="financial-results__table--quarter-btn quarter-btn-disabled">{`Q${quarterNumber}`}</div>
  );
};
interface IProps {
  quarters: IQuarters;
}

export default FinancialQuarterBtn;
